import type { Dispatch, SetStateAction } from 'react';

import type { Subscription } from '@/store/user/types';
import type { JSONObject } from '@/utils/types';

import type { PaymentElementsFormProps } from '..';
import type { OneTimePurchase, RequiresActionResponse } from '../types';
import useSubmitClassicPaymentRequest from './useSubmitClassicPaymentRequest';

export type UseSubmitPaymentRequestProps = Pick<
	PaymentElementsFormProps,
	'analyticsEventProps' | 'analyticsPrefix' | 'endpoint' | 'hasTrueMedSupport' | 'pageName' | 'purchaseArgs'
> & {
	oneTimePurchaseSuccess: (transaction: OneTimePurchase, eventProps?: JSONObject) => Promise<void>;
	onPurchaseError: (
		errorMessageToDisplay: string,
		eventProps?: JSONObject,
		errorCode?: string | JSONObject,
	) => void;
	onPurchaseSuccess: (subscription: Subscription, eventProps?: JSONObject) => Promise<void>;
	onPurchaseSuccessOverride: PaymentElementsFormProps['onPurchaseSuccess'];
	onRequiresAction: ({ clientSecret, customerId, subscriptionId }: RequiresActionResponse) => Promise<void>;
	selectedPaymentType: string | null;
	setIsLoading: Dispatch<SetStateAction<boolean>>;
	setSuccessfullySubmitted: Dispatch<SetStateAction<boolean>>;
};

export default function useSubmitPaymentRequest({
	analyticsEventProps,
	analyticsPrefix,
	endpoint,
	hasTrueMedSupport,
	oneTimePurchaseSuccess,
	onPurchaseError,
	onPurchaseSuccess,
	onPurchaseSuccessOverride,
	onRequiresAction,
	pageName,
	purchaseArgs,
	selectedPaymentType,
	setIsLoading,
	setSuccessfullySubmitted,
}: UseSubmitPaymentRequestProps) {
	const submitClassicPaymentRequest = useSubmitClassicPaymentRequest({
		analyticsEventProps,
		analyticsPrefix,
		endpoint,
		hasTrueMedSupport,
		oneTimePurchaseSuccess,
		onPurchaseError,
		onPurchaseSuccess,
		onPurchaseSuccessOverride,
		onRequiresAction,
		purchaseArgs,
		selectedPaymentType,
		setIsLoading,
		setSuccessfullySubmitted,
	});

	return submitClassicPaymentRequest;
}
